import React, { memo } from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import classNames from 'classnames'
import { ltGtMediaQuery } from 'root/src/client/web/commonStyles'
import { useWindowSize } from 'root/src/client/v2/common/hooks/useWindowSize'
import Slider from 'root/src/client/web/base/Slider'
import identity from 'ramda/src/identity'
import InfiniteScroller from 'root/src/client/web/list/util/InfiniteScroller'
import SidebarItem from './SidebarItem'

const style = {
	root: {
		width: 470,
		padding: [[60, 215, 0, 0]],
		'@media(max-width: 1700px)': {
			width: 268,
			padding: [[60, 15]],
		},
		[ltGtMediaQuery]: {
			width: 'unset',
			padding: [[0, '5%']],
			alignSelf: 'flex-start',
		},
	},
	title: {
		fontSize: 17,
		fontWeight: 500,
		letterSpacing: 0.11,
		marginBottom: 32,
		[ltGtMediaQuery]: {
			fontSize: 18,
			marginBottom: 24,
		},
	},
	sliderMoreDares: {
		flexDirection: 'row',
		display: 'flex',
		justifyContent: 'start',
		maxWidth: 'initial',
	},
}

const SidebarList = memo(({
	classes, isMobileRes, list, currentPage,
	hasMore, getNextPage, moduleId, pageItemLength,
}) => {
	const [width] = useWindowSize()
	const renderDaresList = () => list.map(listItem => <SidebarItem recordId={listItem} />)

	return (renderDaresList().length ? (
		<div className={classNames('layout-column', classes.root)}>
			<div className={classes.title}>More Completed Dares for You</div>
			{
				!isMobileRes
					? InfiniteScroller({
						currentPage,
						hasMore,
						getNextPage,
						moduleId,
						pageItemLength,
					})(renderDaresList())
					: (
						<Slider
							captions
							arrows={false}
							sliderItemsStyle={classes.sliderMoreDares}
							stepMultiplier={1.005}
							showItems={list.length}
							sliderItems={list}
							renderSliderItem={() => identity}
							sliderWidth
							dragActive={width < 1401}
						>
							{renderDaresList()}
						</Slider>
					)
			}
		</div>
	) : null
	)
})

export default withStyles(style, { name: 'MuiSidebarList' })(SidebarList)
